import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { IPerson } from '@shared/model/person.model';
import { SERVER_API_URL } from '@app/app.constants';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PersonService {
  constructor(private http: HttpClient) {}

  register(person: IPerson): Observable<any> {
    return this.http.post(SERVER_API_URL + 'persons/sign-up', person, {
      observe: 'response',
    });
  }

  registerUnCover(person: any): Observable<any> {
    return this.http.post(SERVER_API_URL + 'public/users', person, {
      observe: 'response',
    });
  }

  registerFacebook(person: IPerson): Observable<any> {
    const { token } = person;
    return this.http.post(
      SERVER_API_URL + 'persons/sign-up/facebook',
      { access_token: token, ...person },
      { observe: 'response' }
    );
  }

  registerGoogle(person: IPerson): Observable<any> {
    const { token } = person;
    return this.http.post(
      SERVER_API_URL + 'persons/sign-up/google',
      { access_token: token, ...person },
      { observe: 'response' }
    );
  }

  getPerson(id: any): Observable<any> {
    return this.http.get(SERVER_API_URL + 'persons/' + id, {
      observe: 'response',
    });
  }
  getUserTypes(): Observable<any> {
    return this.http.get(SERVER_API_URL + 'users/types', {
      observe: 'response',
    });
  }
}
